// TODO validate if lodash can replace this
export function jsonEqual(a: any, b: any) {
  return JSON.stringify(a) === JSON.stringify(b)
}